<section class="pt-16 px-container">
    <app-breadcrumb-backoffice [items]="[{ label: 'Home', route: '/backoffice/home' }, { label: 'Email Newsletter', route: '/backoffice/newsletter/' }, { label: 'Aggiungi Email Newsletter', route: '/backoffice/newsletter/add' }]"></app-breadcrumb-backoffice>
</section>

<section class="px-container pb-16">
    <form [formGroup]="formNewsletter" class="accrediti-form flex flex-col gap-6" (ngSubmit)="onSubmit()">
        <div class="ac-section-head">
            <div>
                <h2>Email</h2>
                <span class="ac-meta">indirizzo iscrizione newsletter</span>
            </div>
        </div>

        <div class="fld">
            <label>* Email</label>
            <input type="email" pInputText class="w-full" placeholder="Email" formControlName="email" name="email" id="email" required />
            @if (formNewsletter.get('email')?.hasError('required') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)) {
                <small class="text-red-600 block mt-2 font-medium">L'email è obbligatoria.</small>
            }
            @if (formNewsletter.get('email')?.hasError('email') && (formNewsletter.get('email')?.dirty || formNewsletter.get('email')?.touched)) {
                <small class="text-red-600 block mt-2 font-medium">L'email deve essere valida.</small>
            }
        </div>

        <div class="acc-actions">
            <a class="acc-btn acc-btn-ghost" routerLink="/backoffice/newsletter">Annulla</a>
            <button class="acc-btn acc-btn-primary" type="submit" [disabled]="!formNewsletter.valid">Aggiungi email</button>
        </div>
    </form>
</section>
